import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { jobs } from '../../lib/data';
import { JobCard } from '../jobs/JobCard';
import { Eyebrow, Reveal } from '../ui/Reveal';
import { Button } from '../ui/Button';
export function FeaturedRoles() {
  const featured = jobs.filter(j => j.featured).slice(0, 3);
  return <section className="mx-auto max-w-7xl px-6 py-20 lg:px-10 lg:py-28" data-id="element-30" data-mp="2sdlt9il8har9">
      <div className="flex flex-col items-start justify-between gap-6 sm:flex-row sm:items-end" data-id="element-31" data-mp="3g24zlskq3dgp">
        <div className="max-w-xl" data-id="element-32" data-mp="3k4i7amj15lg4">
          <Eyebrow data-id="element-33" data-mp="3k3gv2eqa2swt">Current mandates</Eyebrow>
          <h2 className="mt-6 font-serif text-3xl leading-tight text-ink sm:text-4xl" data-id="element-34" data-mp="36ctsuclb6kvz">
            Opportunities defining industries.
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-ink-600" data-id="element-35" data-mp="3ba3qugmrk4vf">
            A selection of the leadership roles we are searching for today.
          </p>
        </div>
        <Button to="/opportunities" variant="outline" size="md" className="shrink-0" data-id="element-36" data-mp="7mtmcubh1gh2">
          View all opportunities <ArrowRightIcon className="h-4 w-4" data-id="element-37" data-mp="1q8gfseu8tu1k" />
        </Button>
      </div>

      <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-38" data-mp="1m6d3jnzr2lf8">
        {featured.map((job, i) => <Reveal key={job.id} delay={i * 0.1} data-id="element-39" data-mp="1zxhvs50sgbfj" data-mpi={i}>
            <JobCard job={job} data-id="element-40" data-mp="1zzb3lnn511p4" />
          </Reveal>)}
      </div>
    </section>;
}